import { render, staticRenderFns } from "./SimpleMultiSelect.vue?vue&type=template&id=2ef5f777&scoped=true"
import script from "./SimpleMultiSelect.vue?vue&type=script&lang=js"
export * from "./SimpleMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./SimpleMultiSelect.vue?vue&type=style&index=0&id=2ef5f777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5f777",
  null
  
)

export default component.exports